import React, { useMemo } from 'react';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState as GS } from '../../stores/types/types';
import {
    hideGraphicForShowBuilder,
    showGraphicForShowBuilder,
} from '../../stores/actions/graphics';

interface ShowBuilderCardToggleProps {
    graphicId: number;
}

export default function ShowBuilderCardToggle(props: ShowBuilderCardToggleProps) {
    const { graphicId } = props;
    const dispatch = useDispatch();
    const disabledShowBuilderOverlays = useSelector(
        (state: GS) => state.GraphicsReducer.disabledShowBuilderOverlays,
    );

    const isHidden = useMemo(() => {
        return disabledShowBuilderOverlays?.includes(graphicId) ?? false;
    }, [disabledShowBuilderOverlays?.length, graphicId]);

    const clickHandler = () => {
        dispatch(isHidden
            ? showGraphicForShowBuilder(graphicId)
            : hideGraphicForShowBuilder(graphicId)
        );
    }


    return (
        <div
            className="button-toggle-eye"
            onClick={clickHandler}
        >
            <Icon
                name={isHidden
                    ? ICONS.EYE_HIDDEN
                    : ICONS.EYE_SHOWN
                }
                size={20}
                color={COLORS.WHITE}
            />
        </div>
    );
}